function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "lifebuoy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.788 3.212c-3.749-3.749-9.827-3.749-13.575 0-3.75 3.75-3.75 9.828-0.002 13.576 3.75 3.75 9.828 3.75 13.578 0 3.748-3.749 3.748-9.827-0.001-13.576zM6.748 13.252c-1.797-1.797-1.797-4.709 0-6.505 1.795-1.796 4.709-1.796 6.506 0s1.795 4.709 0 6.505c-1.797 1.797-4.709 1.797-6.506 0zM15.347 12.879c0.968-1.799 0.969-3.959 0-5.759l1.783-0.96c1.289 2.391 1.289 5.29 0.002 7.678l-1.785-0.959zM13.839 2.869l-0.961 1.784c-1.799-0.967-3.959-0.967-5.756 0l-0.961-1.783c2.39-1.288 5.287-1.288 7.678-0.001zM2.87 6.16l1.784 0.961c-0.968 1.798-0.968 3.957-0.001 5.756l-1.784 0.961c-1.288-2.389-1.287-5.287 0.001-7.678zM6.159 17.129l0.961-1.783c1.799 0.969 3.96 0.969 5.759 0l0.961 1.785c-2.392 1.287-5.29 1.287-7.681-0.002z"
});

var SvgLifebuoy = function SvgLifebuoy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    className: "svg svg-lifebuoy",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLifebuoy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lifebuoy.9754406e.svg";
export { ForwardRef as ReactComponent };